<p-button
  appPreventDoubleClick
  styleClass="p-button-outlined"
  icon="fas fa-chevron-circle-left"
  id="previousPhaseButton"
  tooltipPosition="left"
  pTooltip={{toolTip}}
  iconPos="left"
  [disabled]="isDisable"
  (debounceClick)="ChangeControlPreviousPhase()"
></p-button>
